export function TriggerSurveyBoxViewConstructor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;

  return joint.shapes.html.AbstractBoxElementView.extend({
    isElementEditable: false,
    angularTemplate: `
    <div layout="column">
        <div><span>{{ 'parameters/quick_replies/details/graph/trigger_survey_box_description' | translate}}</span></div>
    </div>
    `,
  });
}
